import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import { computed } from "@ember/object"
import type { CardStack } from "@shared/models/card-stack"
import { isArray, isNil, map, sortBy } from "lodash-es"
import styles from "./legacy-customize-templ.module.css"

@tagName("")
export default class LegacyCustomizeTemplate extends Component {
  readonly styles = styles
  cardStack!: CardStack

  @computed("cardStack.attributes.cards.[]")
  get cardAttributes() {
    if (isNil(this.cardStack) || isNil(this.cardStack.attributes)) return []
    let cards = this.cardStack.attributes.cards
    return map(cards, "attributes")
  }

  @computed("cardAttributes.@each.position")
  get sortedCards() {
    let cardAttributes = this.cardAttributes // have to trigger the computed property above
    if (
      isArray(cardAttributes) !== true ||
      isNil(this.cardStack) ||
      isNil(this.cardStack.attributes)
    )
      return undefined
    let cards = this.cardStack.attributes.cards
    return sortBy(cards, "attributes.position")
  }
}
